// themeSlice.js
import { createSlice } from '@reduxjs/toolkit'

const storedDarkMode = localStorage.getItem('darkMode')
let initialState = {}

if (storedDarkMode) {
  initialState = { darkMode: JSON.parse(storedDarkMode) }
} else {
  initialState = { darkMode: false }
  localStorage.setItem('darkMode', false)
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.darkMode = !state.darkMode
      localStorage.setItem('darkMode', JSON.stringify(state.darkMode))
    },
  },
})

export const { toggleTheme } = themeSlice.actions

export default themeSlice.reducer
